import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Form } from "antd";
import { UserContext } from "contexts/userContext";

import Row from "components/shared/Row";
import Col from "components/shared/Col";
import Spin from "components/shared/Spin";
import Modal from "components/shared/Modal";
import PhoneInput from "components/shared/formItems/PhoneInput";
import Input from "components/shared/form/Input";

import { createNewContact } from "services/buyerService";

const NewContact = ({ modalVisible, closeModal, companyName, buyerDetails, contract }) => {
  const { countriesPhoneCodes } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const errorText = (errorCode) => {
    let message = "";

    switch (errorCode) {
      case "SME50":
        message = t("accountNewUserEmailInvalidMessage");
        break;
      case "SME51":
        message = t("accountNewUserFirstNameInvalidMessage");
        break;
      case "SME52":
        message = t("accountNewUserLastNameInvalidMessage");
        break;
      case "SME55":
        message = t("accountNewUserPhoneInvalidMessage");
        break;
      case "SME62":
        message = t("newContactInvalidJobTitle");
        break;
      default:
        message = t("error");
    }

    return message;
  };

  const errorName = (errorCode) => {
    let name = "";

    switch (errorCode) {
      case "SME50":
        name = "email";
        break;
      case "SME51":
        name = "name";
        break;
      case "SME52":
        name = "surname";
        break;
      case "SME55":
        name = "number";
        break;
      case "SME57":
        name = "personalCode";
        break;
      default:
        name = "name";
    }

    return name;
  };

  return (
    <Modal
      width="48.125rem"
      className="new-contact grey medium modal"
      title={t("newContactTitle")}
      visible={modalVisible}
      okText={t("submit")}
      cancelText={t("cancel")}
      cancelButtonProps={{
        className: "button button--default button--large",
      }}
      okButtonProps={{
        className: "button button--primary button--large",
      }}
      onCancel={() => {
        closeModal();
      }}
      onOk={() => {
        form
          .validateFields()
          .then(async ({ name, surname, email, phoneCode, number, jobTitle }) => {
            setLoading(true);
            const result = await createNewContact({
              contractId: contract.id,
              thirdPartytId: buyerDetails.party.id,
              data: {
                email,
                jobTitle: jobTitle ? jobTitle : "",
                name,
                phoneNumber: number ? phoneCode + number : "",
                surname,
              },
            });
            setLoading(false);
            if (result.code) {
              form.setFields([
                {
                  name: errorName(result.code),
                  errors: [errorText(result.code)],
                },
              ]);
            } else {
              closeModal("success");
              form.resetFields();
            }
          })
          .catch((e) => {
            console.log("Validate faild: ", e);
          });
      }}
    >
      <Spin spinning={loading} tip={t("loading") + "..."}>
        <Row>
          <Col>
            <label>{t("newContactCompanyName")}</label>
            <p>{companyName}</p>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <Form
              layout="vertical"
              className="data-form"
              placeholder={t("accountNewPhone")}
              form={form}
              initialValues={{
                phoneCode: "+370",
              }}
            >
              <Row>
                <Col span="11">
                  <Input
                    label={t("newContactName")}
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: t("newContactNameValidation"),
                      },
                    ]}
                  />
                </Col>
                <Col span="2" />
                <Col span="11">
                  <Input
                    label={t("newContactSurname")}
                    name="surname"
                    rules={[
                      {
                        required: true,
                        message: t("newContactSurnameValidation"),
                      },
                    ]}
                  />
                </Col>
              </Row>
              <Row>
                <Col span="11">
                  <Input
                    label={t("newContactEmail")}
                    name="email"
                    rules={[
                      {
                        type: "email",
                        required: true,
                        message: t("newContactEmailValidation"),
                      },
                    ]}
                  />
                </Col>
                <Col span="2" />
                <Col span="11" className="row-without-labels">
                  <PhoneInput name="number" form={form} countriesPhoneCodes={countriesPhoneCodes} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Input label={t("newContactJobTitle")} name="jobTitle" />
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
};

export default NewContact;
